import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Col, Row, Select, Typography } from 'antd';
import PropTypes from 'prop-types';

// Actions
import { get_depots, get_groups, get_regions, get_zones, set_area_filters } from '../../actions/areasActions';

const AreaFilters = (props) => {
	const { orgFilters, areaFilters, setAreaFilters } = props;

	const dispatch = useDispatch();

	const { global_data } = useSelector(state => state.global);

	const { regions, zones, depots, groups } = useSelector(state => state.areas);

	const onChangeAreaFilters = (e, name) => {
		let filters = {...areaFilters};
		let keys = Object.keys(filters);
		
		if (e === null || e === undefined) {
			let idx = keys.indexOf(name);
			for (let index = idx; index < keys.length; index++) {
				const key = keys[index];
				filters[key] = '';
				localStorage.setItem(key, '');
			}
		}
		else {
			filters[name] = e.value;
			localStorage.setItem(name, e.value);
		}

		setAreaFilters(filters);
		dispatch(set_area_filters(filters));
	}

	const createFilters = (orgFilters, areaFilters) => {
		let filters = { organization: orgFilters.organization, workspace: orgFilters.workspace };

		for (const key in areaFilters) {
			if (areaFilters[key] !== '') {
				filters[key] = areaFilters[key];
			}
		}

		return filters;
	}

	useEffect(() => {
		if (orgFilters.organization !== '' && orgFilters.workspace !== '') {
			const filters = createFilters(orgFilters, areaFilters);

			dispatch(get_regions(filters));
			dispatch(get_zones(filters));
			// dispatch(get_depots(filters));
			// dispatch(get_groups(filters));
			// dispatch(get_routes({ ...filters, module: orgFilters.module, skip: 0, limit: 10 }));
		}
	}, [orgFilters, areaFilters]);

	return (
		<Row justify='center' gutter={[16, 16]}>
			<Col className='gutter-row' style={{ zIndex: 10 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }}>
				<Row justify='center'>
					<Typography.Text>{global_data?.organizationTerms?.region}</Typography.Text>
				</Row>
				<Select
					style={{ width: '100%' }}
					options={regions.regions.map(option => ({ value: option._id.$oid, label: option.name }))}
					value={regions.regions.find(option => option._id.$oid === areaFilters.region)?.name}
					onChange={(value, option) => onChangeAreaFilters(option, 'region')}
					disabled={false}
					allowClear={true}
					showSearch
					filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
				/>
			</Col>
			<Col className='gutter-row' style={{ zIndex: 10 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }}>
				<Row justify='center'>
					<Typography.Text>{global_data?.organizationTerms?.zone}</Typography.Text>
				</Row>
				<Select
					style={{ width: '100%' }}
					options={zones.zones.map(option => ({ value: option._id.$oid, label: option.name }))}
					value={zones.zones.find(option => option._id.$oid === areaFilters.zone)?.name}
					onChange={(value, option) => onChangeAreaFilters(option, 'zone')}
					disabled={false}
					allowClear={true}
					showSearch
					filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
				/>
			</Col>
			{/* <Col className='gutter-row' style={{ zIndex: 10 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }}>
				<Row justify='center'>
					<Typography.Text>{global_data?.organizationTerms?.depot}</Typography.Text>
				</Row>
				<SelectButton
					options={depots.depots}
					name='depot'
					value={areaFilters.depot === '' ? null : areaFilters.depot}
					onChange={onChangeAreaFilters}
					disable={false}
					areaFilters={true}
				/>
			</Col>
			<Col className='gutter-row' style={{ zIndex: 10 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }}>
				<Row justify='center'>
					<Typography.Text>{global_data?.organizationTerms?.group}</Typography.Text>
				</Row>
				<SelectButton
					options={groups.groups}
					name='group'
					value={areaFilters.group === '' ? null : areaFilters.group}
					onChange={onChangeAreaFilters}
					disable={false}
					areaFilters={true}
				/>
			</Col> */}
		</Row>
	);
}

AreaFilters.propTypes = {
	orgFilters: PropTypes.object.isRequired,
	areaFilters: PropTypes.object.isRequired,
	setAreaFilters: PropTypes.func.isRequired
};

export default AreaFilters;
